/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import WaitIcon from './WaitIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ActionType/Content/ActionType/No",
  text
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let eventActionNameValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'name',
})
  return (<React.Fragment
>
<div
  data-testid="No.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<WaitIcon
  viewPath={`${viewPath}/WaitIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text={text}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event_action.name"
 text={eventActionNameValueData}
/>
</div>
{children}
</React.Fragment>)
}